export default {
  title: 'Создание рассылки'
}
